
const CONFIG = {
  DOMAIN: process.env.REACT_APP_DOMAIN,
  APP_URL: process.env.REACT_APP_APP_URL,
  API_DOMAIN: process.env.REACT_APP_API_DOMAIN,
  BASE_PATH: process.env.REACT_APP_BASE_PATH,
  GENERIC_API_KEY: process.env.REACT_APP_GENERIC_API_KEY,
  SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL,
  APP_STORE_ID:          process.env.REACT_APP_APP_STORE_ID,
  ANDROID_APP_IDENTIFIER:process.env.REACT_APP_ANDROID_APP_IDENTIFIER,
};

export default CONFIG;
